// /help — search, topics and the FAQ (signed-in app; content from helpContent.json).
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import AppTransition from '../components/appComponents/AppTransition';
import { getArticlesForCollection, helpArticles, helpCollections, searchHelpArticles } from './helpUtils';
import { ArticleList, ContactCard, topicIcon } from './helpParts';
import './helpCenter.css';

// The FAQ collection is listed out on this page; the other collections are topic cards
const isFaq = collection => /frequently-asked/.test(collection.slug);
const faq = helpCollections.find(isFaq);
const topics = helpCollections.filter(collection => !isFaq(collection));

const HelpHome = () => {
  const [query, setQuery] = useState('');
  const searching = query.trim().length > 0;
  const results = searchHelpArticles(query);

  return (
    <AppTransition>
      <div className="help-page">
        <h1 className="help-title">Help</h1>
        <p className="help-subtitle">Guides and answers from the Bumpups team.</p>

        <div className="help-search">
          <FontAwesomeIcon icon={faMagnifyingGlass} className="help-search-icon" />
          <input
            type="search"
            className="help-search-input"
            placeholder={`Search ${helpArticles.length} articles`}
            value={query}
            onChange={e => setQuery(e.target.value)}
            aria-label="Search help articles"
          />
          {searching && (
            <button type="button" className="help-search-clear" onClick={() => setQuery('')} aria-label="Clear search">
              <FontAwesomeIcon icon={faXmark} />
            </button>
          )}
        </div>

        {searching ? (
          <section className="help-section">
            <div className="help-section-head">
              <h2 className="help-section-title">Results</h2>
              <span className="help-section-meta">{results.length} found</span>
            </div>
            {results.length > 0
              ? <ArticleList articles={results} />
              : <p className="help-empty">No articles match “{query.trim()}”. Try other words, or email us below.</p>}
          </section>
        ) : (
          <>
            <section className="help-section">
              <h2 className="help-section-title">Topics</h2>
              <div className="help-topics">
                {topics.map(collection => (
                  <Link key={collection.slug} to={`/help/${collection.slug}`} className="help-topic">
                    <span className="help-topic-icon"><FontAwesomeIcon icon={topicIcon(collection.slug)} /></span>
                    <span className="help-topic-text">
                      <span className="help-topic-title">{collection.title}</span>
                      <span className="help-topic-desc">{collection.description}</span>
                      <span className="help-topic-count">{getArticlesForCollection(collection.slug).length} articles</span>
                    </span>
                  </Link>
                ))}
              </div>
            </section>

            {faq && (
              <section className="help-section">
                <h2 className="help-section-title">Frequently asked questions</h2>
                <ArticleList articles={getArticlesForCollection(faq.slug)} />
              </section>
            )}
          </>
        )}

        <ContactCard />
      </div>
    </AppTransition>
  );
};

export default HelpHome;
